import { ClickEvent } from "@mcleod/components";
import { Model, ModelRow, Navigation, PermissionsUtil, UrlUtil } from "@mcleod/core";
import { AutogenLayoutRevenueDetailQuickInfo } from "./autogen/AutogenLayoutRevenueDetailQuickInfo";

export class RevenueDetailQuickInfo extends AutogenLayoutRevenueDetailQuickInfo {

    async buttonOpenTariffItemOnClick(event: ClickEvent) {
        const modelTli: ModelRow = await Model.searchSingleRecord("lme/dispatch/tariff-line-item", { tli_uid: this.activeRow.get("tli_uid") });
        const urlParams = {mode: "update", key: modelTli.data["tar_uid"], tli_uid: this.activeRow.get("tli_uid")};
        const url = "/lme/dispatch/TariffManagement" + UrlUtil.buildQueryString(urlParams);
        Navigation.navigateTo(url, { newTab: true });
        window.focus();
    }
}
